import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  constructor(private angularFireMessaging: AngularFireMessaging) {
    //REV
    // this.angularFireMessaging.messaging.subscribe(
    //   (_messaging) => {
    //     _messaging.onMessage = _messaging.onMessage.bind(_messaging);
    //     _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
    //   }
    // )
  }

  requestPermission() {
    this.angularFireMessaging.requestPermission
    .subscribe({
      next: token => {
        // Upload the user FCM token to your server.
      },
      error: err => {
        console.error('permission error: ', +err)
      }
  });
    this.angularFireMessaging.requestToken.subscribe({
      next: token => {
        // Upload the user FCM token to your server.
      },
      error: err => {
        console.error('Fetching FCM token failed: ', +err)
      }
  });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log("new message received. ", payload);
        this.currentMessage.next(payload);
      })
  }
}